import React, { useState, useEffect } from 'react';
import BookDemoButton from '../../../../../BookDemoButton';
import ContactFormModal from '../ContactFormModal/ContactFormModal';
import './Hero.css';

// Rotating words for typing animation - NDT Industry focused
const TYPING_WORDS = ["Inspection", "Reporting", "NDT", "Welding", "Quality Control"];

function Hero() {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentText, setCurrentText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [typingSpeed, setTypingSpeed] = useState(150);
  const [showContactModal, setShowContactModal] = useState(false);

  useEffect(() => {
    const handleTyping = () => {
      const currentWord = TYPING_WORDS[currentWordIndex];
      
      if (isDeleting) {
        // Deleting characters
        setCurrentText(currentWord.substring(0, currentText.length - 1));
        setTypingSpeed(50);
      } else {
        // Typing characters
        setCurrentText(currentWord.substring(0, currentText.length + 1));
        setTypingSpeed(150);
      }

      // When word is complete
      if (!isDeleting && currentText === currentWord) {
        setTimeout(() => setIsDeleting(true), 2000); // Pause before deleting
      } else if (isDeleting && currentText === "") {
        setIsDeleting(false);
        setCurrentWordIndex((prev) => (prev + 1) % TYPING_WORDS.length);
      }
    };

    const timer = setTimeout(handleTyping, typingSpeed);
    return () => clearTimeout(timer);
  }, [currentText, isDeleting, currentWordIndex, typingSpeed]);

  return (
    <section className="position-relative overflow-hidden">
      <div className="position-relative bg-dark zindex-4 pt-lg-3 pt-xl-5">
        
        {/* Text */}
        <div className="container zindex-5 pt-5">
          <div className="row justify-content-center text-center pt-4 pb-sm-2 py-lg-5">
            <div className="col-xl-8 col-lg-9 col-md-10 py-5">
              <h1 className="display-4 text-light pt-sm-2 pb-1 pb-sm-3 mb-3">
                The AI <span className="text-gradient">{currentText}<span className="typing-cursor">|</span></span> <br /> Compliance Platform
              </h1>
              <p className="fs-lg text-light opacity-80 pb-2 pb-sm-0 mb-4 mb-sm-5">
              The Platform that Enables Technicians, Quality Teams, and AI Agents to Work Together.

              </p>
              <div className="hero-cta-buttons pb-2 pt-lg-2 pt-xl-0">
                <BookDemoButton label="Book a Demo" id="heroBookDemo" />
                <button onClick={() => setShowContactModal(true)} className="btn btn-lg btn-outline-primary">Talk to Expert</button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom shape */}
        <div className="d-flex position-absolute top-100 start-0 w-100 overflow-hidden mt-n4 mt-sm-n1" style={{ color: '#131022' }}>
          <div className="position-relative start-50 translate-middle-x flex-shrink-0" style={{ width: '3788px' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="3788" height="144" viewBox="0 0 3788 144">
              <path fill="currentColor" d="M0,0h3788.7c-525,90.2-1181.7,143.9-1894.3,143.9S525,90.2,0,0z"/>
            </svg>
          </div>
        </div>
        <div className="d-none d-lg-block" style={{ height: '300px' }}></div>
        <div className="d-none d-md-block d-lg-none" style={{ height: '150px' }}></div>
      </div>
      
      <div className="position-relative zindex-5 mx-auto px-3 px-sm-4 px-md-4 px-lg-5" style={{ maxWidth: '1100px', transform: 'translateZ(-100px)' }}>
        <div className="d-none d-lg-block" style={{ marginTop: '-300px' }}></div>
        <div className="d-none d-md-block d-lg-none" style={{ marginTop: '-150px' }}></div>
          
        {/* Hero video */}
        <div className="tilt-3d" data-tilt data-tilt-full-page-listening data-tilt-max="12" data-tilt-perspective="1200">
          <video 
            src={`${process.env.PUBLIC_URL}/assets/home_page/v3/videos/orbix-website-video.mp4`}
            className="w-100 rounded-3  shadow-lg"
            autoPlay
            loop
            muted
            playsInline
            onError={(e) => {
              console.error('Video failed to load');
              e.target.style.display = 'none';
            }}
          />
        </div>
      </div>
      
      <div className="position-absolute top-0 start-0 w-100 h-100" style={{ backgroundColor: 'rgba(255,255,255,.05)' }}></div>

      <ContactFormModal show={showContactModal} onClose={() => setShowContactModal(false)} />
    </section>
  );
}

export default Hero;

